import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class PasswordChange extends Component {
  constructor() {
    super();
    this.state = {
      password1: '',
      password2: '',
    };
  }

  componentWillMount() {
    this.props.loadProfile();
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.PASSWORD_CHANGE_SUCCESS) {
        this.props.alert(
          'success',
          'Your password has been updated successfully!'
        );
      }
    }
  }

  handleValue = (e, key) => {
    this.setState({ [key]: e.target.value });
  };

  save = (e) => {
    e.preventDefault();

    this.props.hideAlert();

    if (!this.state.password1) {
      this.props.alert('error', 'Please input new password.');
    } else if (this.state.password1 !== this.state.password2) {
      this.props.alert('error', 'Password does not match.');
    } else {
      let data = {
        new_password1: this.state.password1,
        new_password2: this.state.password2,
      };

      this.props.changePassword(data);
    }
  };

  render() {
    const { profile } = this.props;

    return (
      <div className="user-profile">
        <div className="password-change">
          <Form onSubmit={this.save}>
            <h1 className="text-center">{profile.name}</h1>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>New Password:{' '}
              </ControlLabel>
              <FormControl
                type="password"
                required
                value={this.state.password1}
                onChange={(e) => this.handleValue(e, 'password1')}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>New Password Again:{' '}
              </ControlLabel>
              <FormControl
                type="password"
                required
                value={this.state.password2}
                onChange={(e) => this.handleValue(e, 'password2')}
              />
            </FormGroup>
            <FormGroup className="text-right">
              <button type="submit">Save</button>
            </FormGroup>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  status: state.profile.status,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
  changePassword: (data) => {
    dispatch(actions.changePassword(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChange);



// WEBPACK FOOTER //
// src/components/Profile/PasswordChange.jsx